import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

// Lazy Loaded Modules
const Bootcamp4Activities = dynamic(() => import('./Bootcamp4/Bootcamp4Activities'))

const StatisticsActivities = (activityData: ActivityGroupProps): React.ReactElement => {
  const router = useRouter()
  const { moduleKey } = router.query

  switch (moduleKey) {
    case '4':
      return <Bootcamp4Activities {...activityData} />
    default:
      return <></>
  }
}

export default StatisticsActivities
